import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Inject, Injectable, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ModalService {
  private modalClosedSource = new Subject<void>();

  modalClosed$ = this.modalClosedSource.asObservable();

  closeModal(): void {
    this.modalClosedSource.next();
  }
}

@Component({
  selector: 'app-beacon-devices-modal',
  templateUrl: './beacon-devices-modal.component.html',
  styleUrl: './beacon-devices-modal.component.scss'
})
export class BeaconDevicesModalComponent  implements OnInit  {

  modalTitle: string;
  modalMessage: any;
  linkToLadingForm!: FormGroup;
  setCourierForm!: FormGroup;  

  spinner: boolean = false

  
  constructor(
    public dialogRef: MatDialogRef<BeaconDevicesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private http: HttpClient,
    private toastr: ToastrService,
    private modalService: ModalService,
    private formBuilder: FormBuilder
  ) {
    this.modalTitle = data.data.modalTitle;
    this.modalMessage = data.data.modalMessage;

    console.log('Modal Message:', this.modalMessage);

    this.linkToLadingForm = this.fb.group({
      beacon_device_uuid: this.modalMessage.beacon_device_uuid,
      alternate_reference: this.modalMessage.alternate_reference,
    });    

    this.setCourierForm = this.fb.group({
      beacon_device_uuid: this.modalMessage.beacon_device_uuid,
      return_courier: this.modalMessage.return_courier,
      tracking_number: this.modalMessage.tracking_number,      
    });   

  }

  ngOnInit(): void {

  }

  linkToLading() {
    const postData = this.linkToLadingForm.value;

    console.log('Post Data:', postData);
    const link_to_lading_url = `/api/beacon_devices/beacon_devices.php?command=LINK_TO_LADING`;

    return this.http.put<any>(link_to_lading_url, postData)
      .subscribe(response => {
        console.log('Return Message:', response);
          this.closeModal();
          if (response['data'] === 'OK')
          {
            this.toastr.success('You Linked to a Lading successfully.', "SUCCESS", {
                  positionClass : "toast-center-center",
              });    
          }
          else
          {
              this.toastr.error(response['data'], "FAILED", {
                  positionClass : "toast-center-center",
              });    
          }
      })
  }


  resetLink() {
    const postData = this.linkToLadingForm.value;

    console.log('Post Data:', postData);
    const reset_link_url = `/api/beacon_devices/beacon_devices.php?command=RESET_LINK`;

    return this.http.put<any>(reset_link_url, postData)
      .subscribe(response => {
        console.log('Return Message:', response);
          this.closeModal();
          if (response['data'] === 'OK')
          {
            this.toastr.success('You Reset the Link successfully.', "SUCCESS", {
                  positionClass : "toast-center-center",
              });    
          }
          else
          {
              this.toastr.error(response['data'], "FAILED", {
                  positionClass : "toast-center-center",
              });    
          }
      })
  }

    setCourier() {
    const postData = this.setCourierForm.value;

    console.log('Post Data:', postData);
    const link_to_lading_url = `/api/beacon_devices/beacon_devices.php?command=SET_RETURN_COURIER`;

    return this.http.put<any>(link_to_lading_url, postData)
      .subscribe(response => {
        console.log('Return Message:', response);
          this.closeModal();
          if (response['data'] === 'OK')
          {
            this.toastr.success('You Set a Return Courier successfully.', "SUCCESS", {
                  positionClass : "toast-center-center",
              });    
          }
          else
          {
              this.toastr.error(response['data'], "FAILED", {
                  positionClass : "toast-center-center",
              });    
          }
      })
  }

  resetReturnCourier() {
    const postData = this.setCourierForm.value;

    console.log('Post Data:', postData);
    const reset_link_url = `/api/beacon_devices/beacon_devices.php?command=RESET_COURIER`;

    return this.http.put<any>(reset_link_url, postData)
      .subscribe(response => {
        console.log('Return Message:', response);
          this.closeModal();
          if (response['data'] === 'OK')
          {
            this.toastr.success('You Reset the Return Courier successfully.', "SUCCESS", {
                  positionClass : "toast-center-center",
              });    
          }
          else
          {
              this.toastr.error(response['data'], "FAILED", {
                  positionClass : "toast-center-center",
              });    
          }
      })
  }

  scanNewBeacons() {
    const postData = '';

    const scan_for_new_beacons_url = `/api/beacon_devices/beacon_devices.php?command=SCAN_FOR_NEW_BEACONS`;

    return this.http.put<any>(scan_for_new_beacons_url, postData)
      .subscribe(response => {
        console.log('Return Message:', response);
          this.closeModal();
          if (response['data'] === 'OK')
          {
            this.toastr.success('You Scanned for New Beacons successfully.', "SUCCESS", {
                  positionClass : "toast-center-center",
              });    
          }
          else
          {
              this.toastr.error(response['data'], "FAILED", {
                  positionClass : "toast-center-center",
              });    
          }
      })
  }
  closeModal() {
    this.dialogRef.close();
  }

}

